// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\FeatureFlippingResponse

import { FeatureFlag } from './enums.gen';

export type FeatureFlippingApiResponse = {
	features: FeatureFlag[];
};

export type FeatureFlipping = {
	features: FeatureFlag[];
};

export function hydrateFeatureFlipping(data: FeatureFlippingApiResponse): FeatureFlipping {
	return { ...data };
}